import '../css/registration.scss';
import {h, render} from 'preact';
import $ from '@modules/jquery-import';
import {jqueryValidate} from '@modules/lazy-imports'
import {HashRouter} from 'react-router-dom';

import RegistrationContainer from '@containers/Registration';


$( document ).ready( () => {

    const domRegistration = document.getElementById( 'registration' );
    if ( domRegistration ) {
        render(
            <HashRouter>
                <RegistrationContainer/>
            </HashRouter>,
            null, domRegistration );
    }

    const usLogin = document.getElementById( 'usLogin' );
    if ( usLogin ) {
        showHidePassword();
        jqueryValidate().then( () => {
            $( usLogin ).validate();
        } );
    }

    const frRegistration = document.getElementById( 'frenchRegistrationForm' );
    if ( frRegistration ) {
        showHidePassword();
        jqueryValidate().then( () => {
            $( frRegistration ).validate();
        } )
    }

    function showHidePassword () {
        var $passwordShowHide_container = $( '#showHide-password' );
        var $passwordShowHide_icon = $( '#showHide-password-icon' );
        var $passwordShowHide_iconUse = $( '#showHide-password-icon use' );
        var $passwordInput = $( '#password' );
        $passwordShowHide_container.on( 'click', '.svgi-eye-open', function () {
            $passwordShowHide_container.attr( 'data-tooltip', 'Hide Password' );
            $passwordInput.attr( 'type', 'text' );
            $passwordShowHide_icon.removeClass( 'svgi-eye-open' ).addClass( 'svgi-eye-closed' );
            $passwordShowHide_iconUse.attr( 'xlink:href', '/svg/ui-defs.svg#icon-eye-closed' );
        } );

        $passwordShowHide_container.on( 'click', '.svgi-eye-closed', function () {
            $passwordShowHide_container.attr( 'data-tooltip', 'Show Password' );
            $passwordInput.attr( 'type', 'password' );
            $passwordShowHide_icon.removeClass( 'svgi-eye-closed' ).addClass( 'svgi-eye-open' );
            $passwordShowHide_iconUse.attr( 'xlink:href', '/svg/ui-defs.svg#icon-eye-open' );
        } );
    }

} );

